export default "__VITE_ASSET__rWKcX9ho__"